import { Injectable } from "@angular/core";
import { ItemDataService } from "../item-data.service";
import { Mod, ModItemCategory, TieredMod } from "../../models/item-data-models";
import { Filter } from "../../models/filter-models";

@Injectable({
  providedIn: 'root'
})
export class ModTierService {
  private modTierData: TieredMod[] = [];

  constructor(private itemDataService: ItemDataService) {
  }

  combineModTierListData(filter: Filter) {
    const tieredMods = this.itemDataService.getTieredMods();
    const tieredModsClone = structuredClone(tieredMods) as TieredMod[];

    filter.customModTiers.forEach(customItem => {
      const existingMod = tieredModsClone.find(p => p.cat === customItem.cat && p.name === customItem.name);
      if (existingMod) {
        existingMod.originalTier = existingMod.tier;
        existingMod.tier = customItem.tier;
      } else {
        tieredModsClone.push({
          ...customItem,
          originalTier: 'Neutral' // If it didn't exist yet, it must have been a neutral mod
        });
      }
    });

    const modData = this.itemDataService.getModData()();
    if (modData.length > 0) {
      tieredModsClone.forEach(mod => {
        mod.mods = modData.filter(m => m.name === mod.name);
      });
    }

    this.modTierData.length = 0;
    this.modTierData.push(...tieredModsClone);
  }

  getModTierData() {
    return this.modTierData;
  }

  assignTiersToModOfTypeGivenItemCategory(mods: Mod[], category?: ModItemCategory): { mod: Mod, tier: number }[] {
    const modsThatApplyToCategory = mods
      .sort((a, b) => a.lvl - b.lvl)
      .filter(mod => !category ? true : this.modCanSpawnOnCategory(mod, category));

    return modsThatApplyToCategory
      .map((mod, index) => ({ mod, tier: modsThatApplyToCategory.length - index }));
  }

  modCanSpawnOnCategory(mod: Mod, category: ModItemCategory): boolean {
    return (mod.slots.some(slot => category.slots.includes(slot.techName)) || mod.slots.some(slot => slot.techName === 'default'))
      && !mod.exSlots.some(ex => ex.techName === category.slots[0]) && (category.slots.length === 1 || !mod.exSlots.some(ex => ex.techName === category.slots[1]));
  }

  modCanSpawnOnSlots(mod: Mod, slots: string[]): boolean {
    return (mod.slots.some(slot => slots.includes(slot.techName)) || mod.slots.some(slot => slot.techName === 'default'))
      && !mod.exSlots.some(ex => ex.techName === slots[0]) && (slots.length === 1 || !mod.exSlots.some(ex => ex.techName === slots[1]));
  }
}
